import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { createReport } from "../../../apis/reports";
import { NEED_TO_UPDATE, ULTRASOUND_SCAN } from "../../../constants/Constants";
import { ReportObjCreator } from "../../../util/api.helpers";
import {
  getNameValueObject,
  objectBuilderForPDF,
} from "../../../util/data.util";
import { UltrasoundFormInputs } from "../../../util/reportsCreation/report.formHelper";
import { downloadUltrasoundReport } from "../../../util/reportsCreation/ultrasoundReportPdf";
import PrimaryButton from "../../buttons/PrimaryButton";
import TextInput from "../../fromComponents/TextInput";
import { useSelector } from "react-redux";
import { todaysDate } from "../../../util/getTodaysDate";
import ComponentLoading from "../../loading/ComponentLoading";
import AddDownload from "../../OptionsComponents/AddDownload";
import {
  CREATE_SUCCESS,
  CREATE_FAILED,
  DOWNLOAD_FAILED,
  DOWNLOAD_SUCCESS,
} from "../../../constants/SnackbarMessages";
import useSnackbar from "../../../hooks/useSnackbar";
import TextInputFull from "../../fromComponents/TextInputFull";
import { setProgressNotes } from "../../../redux/slice/progressNotesSlice";
import { useDispatch } from "react-redux";

export const UltrasoundReport = React.memo(() => {
  const patientObject: any = useSelector<PatientState>(
    (state) => state.patient
  );
  const { patient } = patientObject;
  const partnerObject: any = useSelector<PartnerState>(
    (state) => state.partner
  );
  const { partner } = partnerObject;
  const userObject: any = useSelector<UserState>((state) => state.user);
  const { signature } = userObject.user.staff;
  const [reportObj, setReportObj] = useState<UltrasoundScanType>();
  const { register, handleSubmit, reset } = useForm<UltrasoundScanType>();
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { successSnackbar, errorSnackbar } = useSnackbar();
  const progressNotes: any = useSelector<ProgressNotesState>(
    (state) => state.progressNotes
  );
  const dispatch = useDispatch();

  const onSubmit = async (patientData: UltrasoundScanType) => {
    setIsLoading(!isLoading);
    patientData.reportDate = todaysDate();
    patientData.signature = signature;
    setReportObj(
      objectBuilderForPDF(
        patient,
        patient.partnerPublicId ? partner : null,
        patientData
      )
    );
  };

  const handleDownload = () => {
    if (reportObj) {
      downloadUltrasoundReport(reportObj);
      handleReset();
      successSnackbar(DOWNLOAD_SUCCESS);
    } else {
      errorSnackbar(DOWNLOAD_FAILED);
    }
  };

  const handleReset = () => {
    reset(); // Reset the form fields
    setIsDisable(true);
    setReportObj(undefined);
  };

  const createNewReport = async () => {
    if (reportObj) {
      const values = getNameValueObject(reportObj);
      const [response, error] = await createReport(
        ReportObjCreator(
          ULTRASOUND_SCAN,
          reportObj.patientId,
          reportObj.patientName,
          reportObj.patientDOB,
          values
        )
      );
      if (response) {
        successSnackbar(`Report ${CREATE_SUCCESS}`);
        setIsDisable(false);
        setIsLoading(false);
        dispatch(setProgressNotes([...progressNotes.data, response]));
      } else {
        errorSnackbar(`${CREATE_FAILED} Report.${error}`);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    createNewReport();
  }, [reportObj]);

  return isDisable ? (
    <>
      {isLoading ? (
        <ComponentLoading />
      ) : (
        <div className="col-sm-12 ">
          <div className="col-sm-12 p-3">
            <h3 className="text-center">Ultrasound Scan Report</h3>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-sm-12 p-2">
              <div className="row ms-1">
                {UltrasoundFormInputs.map((item: InputFieldType) => {
                  return item.id !== "additionalComments" ? (
                    <TextInput
                      keyName={item.id}
                      register={register}
                      placeholder={item.placeholder}
                      id={item.id}
                      label={item.label}
                      type={item.type}
                      listName={item.id + "list"}
                      options={item.options}
                      required={item.required}
                      tag={item.tag}
                      maxLength={item.maxLength}
                      minRows={item.minRows}
                    />
                  ) : (
                    <TextInputFull
                      keyName={item.id}
                      register={register}
                      placeholder={item.placeholder}
                      id={item.id}
                      label={item.label}
                      type={item.type}
                      listName={item.id + "list"}
                      options={item.options}
                      required={item.required}
                      tag={item.tag}
                      maxLength={item.maxLength}
                      minRows={item.minRows}
                    />
                  );
                })}
              </div>
            </div>

            <PrimaryButton label={"Save"} type={"submit"} className={""} />
          </form>
        </div>
      )}
    </>
  ) : (
    <AddDownload onDownload={handleDownload} onReset={handleReset} />
  );
});
